import Loading from 'quasar/src/plugins/loading/Loading.js';
import { isMatchKeyword } from "src/extensions/utils/KeywordSearch";
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { api } from "~/api";
import { MsgBox } from "~/components/MsgBox";
import MypageBadge from "~/components/MypageBadge.vue";
import MyPageTable from "~/components/MyPageTable.vue";
import { Pagination } from "~/extensions/api";
import { Log } from "~/extensions/utils";
import { HanyoKb, PageID, RoomSb } from "~/extensions/utils/DefineTypes";
import { PagingListHelper } from "~/extensions/utils/PagingHelper";
import { RoomSelectFindConditionViewModel } from "~/pages/common/models/RoomSelectFindConditionViewModel";
import { myPageStore } from "~/store/MyPageStore";
import { RoomSelectFindConditionValidator } from "../Models/RoomSelectFindConditionValidator";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { commonStore } from "~/store/CommonStore";
import { store } from "../store/TaikyoStore";
const log = Log.create("TaikyoAppliedList");
export default defineComponent({
    components: {
        MypageBadge,
        MyPageTable,
        BreadcrumbList
    },
    name: "TaikyoAppliedList",
    setup() {
        const router = useRouter();
        // 画面ヘッダーとパンくず
        const pageName = commonStore.pageName(PageID.taikyoAppliedList);
        const isFromBulkRoom = history.state.isFromBulkRoom;
        // 検索欄
        const condition = ref(new RoomSelectFindConditionViewModel());
        const valid = ref(new RoomSelectFindConditionValidator(condition.value));
        // 一覧表示
        const allAppliedList = ref([]);
        const appliedList = ref([]);
        const pagination = ref(new Pagination("nyukyokeiyakuNo", false));
        const columns = [
            { name: "roomIcon", label: "", align: "left", field: "roomIcon", sortable: false },
            { name: "bukkenName", label: "物件名", align: "left", field: "bukkenName", sortable: false },
            { name: "roomNumber", label: "号室", align: "left", field: "roomNumber", sortable: false },
            { name: "nyukyosha", label: "入居者名", align: "left", field: "nyukyosha", sortable: false },
            { name: "tahtosha", label: "担当者名", align: "left", field: "tahtosha", sortable: false },
            { name: "taikyoYmd", label: "退去予定日", align: "left", field: "taikyoYmd", sortable: false },
            { name: "taikyoStatus", label: "申請状況", align: "center", field: "taikyoStatus", sortable: false }
        ];
        // 検索処理
        const onSearch = () => {
            const searchList = allAppliedList.value.filter(x => isFiltered(x));
            pagination.value.rowsNumber = searchList.length;
            appliedList.value = searchList.slice(0, pagination.value.rowsPerPage);
        };
        function isFiltered(appliedItem) {
            const keyword = condition.value.keyword?.trim();
            if (!keyword) {
                return true;
            }
            return (isMatchKeyword(appliedItem.bukenName, keyword) || isMatchKeyword(appliedItem.roomNo, keyword) || isMatchKeyword(appliedItem.nyukyosha, keyword) || isMatchKeyword(appliedItem.tantosha, keyword));
        }
        // ページング処理
        const pagingListHelper = new PagingListHelper({
            mode: "ref",
            list: allAppliedList,
            pagination,
            load: async () => {
                const res = await api.taikyoNotification.getAppliedList(myPageStore.personal.userCd);
                allAppliedList.value = res.records;
                pagination.value.rowsNumber = allAppliedList.value.length;
            },
            resetPagination: () => {
                appliedList.value = [];
            }
        }, log);
        //ページング処理
        const onRequest = async (requestData) => {
            Loading.show();
            await pagingListHelper.paging(requestData);
            const page = requestData?.page ?? pagination.value.page;
            const rowsPerPage = requestData?.rowsPerPage ?? pagination.value.rowsPerPage;
            if (rowsPerPage === 0) {
                appliedList.value = allAppliedList.value;
            }
            else {
                const start = (page - 1) * rowsPerPage;
                const end = start + rowsPerPage;
                appliedList.value = allAppliedList.value.slice(start, end);
            }
            Loading.hide();
        };
        // 行操作
        const isParking = (row) => {
            return row.roomSb === RoomSb.Parking;
        };
        const onPush = (taikyoNo) => {
            const nyukyokeiyaku = myPageStore.personal.nyukyokeiyakuList.find(x => x.orgNyukyokeiyakuNo === taikyoNo);
            if (nyukyokeiyaku) {
                store.selectedRooms = [nyukyokeiyaku];
                router.push({ name: "taikyo-applied-list-next", state: { isFromBulkRoom: isFromBulkRoom } });
            }
        };
        // 初期表示処理
        const initView = async () => {
            try {
                Loading.show();
                const res = await api.taikyoNotification.getAppliedList(myPageStore.personal.userCd);
                allAppliedList.value = res.records;
                pagination.value.rowsNumber = allAppliedList.value.length;
                appliedList.value = allAppliedList.value.slice(0, pagination.value.rowsPerPage);
            }
            catch (ex) {
                log.error("apply", ex);
                if (ex.data.status !== 404) {
                    MsgBox.error(ex.message);
                }
            }
            finally {
                Loading.hide();
            }
        };
        initView();
        return {
            myPageStore,
            HanyoKb,
            router,
            columns,
            onSearch,
            pagination,
            condition,
            isParking,
            onPush,
            allAppliedList,
            appliedList,
            onRequest,
            valid,
            pageName,
            PageID,
            isFromBulkRoom
        };
    }
});
